export enum ObjectState {
	Deleted = 'deleted',
	Modified = 'modified',
	Created = 'created',
}
